var map = {
	"./en_us": [
		36968,
		968
	],
	"./en_us.js": [
		36968,
		968
	],
	"./ja_jp": [
		71052,
		52
	],
	"./ja_jp.js": [
		71052,
		52
	],
	"./zh_cn": [
		13434,
		434
	],
	"./zh_cn.js": [
		13434,
		434
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96591;
module.exports = webpackAsyncContext;